export const attachmentDetails = {
  'secure': {
    analysis: `안정형 애착은 가장 건강한 애착 유형입니다. 초기 양육자와의 관계에서 일관된 돌봄과 정서적 지지를 경험했으며, 이를 통해 자신과 타인에 대한 긍정적인 내적 작동 모델을 형성했습니다.

형성 과정에서 양육자는 아이의 필요에 적절하게 반응하고, 안전 기지(secure base)로서의 역할을 충실히 수행했습니다. 아이가 불안하거나 스트레스 상황에 처했을 때 안정적인 위로와 지지를 제공받았으며, 동시에 독립적인 탐색을 할 수 있는 자유도 보장받았습니다.

실제 관계에서는 건강한 친밀감과 자율성의 균형을 보여줍니다. 예를 들어, 파트너와의 관계에서 깊은 정서적 유대를 형성하면서도 각자의 개별성을 존중하거나, 어려운 상황에서 도움을 요청하는 것을 자연스럽게 여기면서도 독립적으로 문제를 해결할 수 있는 능력도 가지고 있습니다.

연인 관계에서는 안정적이고 신뢰로운 파트너가 됩니다. 상대방의 독립성을 존중하면서도 필요할 때 적절한 지지와 돌봄을 제공할 수 있으며, 갈등 상황에서도 건설적인 대화와 해결을 추구합니다. 친밀감과 거리두기의 균형을 잘 조절하며, 상대방의 애착 스타일을 이해하고 수용하는 능력이 있습니다.

이러한 안정형 애착은 스트레스나 갈등 상황에서도 안정적으로 유지됩니다. 관계에서 발생하는 문제를 건설적으로 해결할 수 있으며, 상대방의 감정을 공감하고 자신의 감정도 적절히 표현할 수 있습니다. 또한 실패나 거절을 경험하더라도 자존감이 크게 흔들리지 않습니다.`,
    development: [
      "현재의 건강한 애착 패턴을 유지하고 발전시키세요",
      "다른 애착 유형을 가진 사람들을 이해하고 지지하는 역할을 해보세요",
      "관계에서의 균형잡힌 태도를 계속 실천하세요",
      "자신의 감정 조절 능력을 다른 영역에도 적용해보세요",
      "건강한 경계 설정의 모델이 되어주세요"
    ]
  },
  'anxious': {
    analysis: `불안형 애착은 관계에서 과도한 불안과 집착을 보이는 유형입니다. 초기 양육자와의 관계에서 일관성 없는 돌봄이나 과잉보호를 경험했으며, 이로 인해 타인에 대한 과도한 의존과 버림받음에 대한 두려움이 형성되었습니다.

형성 과정에서 양육자는 때로는 과도하게 개입하고, 때로는 정서적으로 불안정한 반응을 보였습니다. 아이는 양육자의 관심과 사랑을 얻기 위해 과도하게 신호를 보내야 했으며, 이는 성인이 된 후에도 관계에서 과도한 확신 추구 행동으로 이어집니다.

실제 관계에서는 강한 친밀감 욕구와 버림받음에 대한 두려움이 특징적으로 나타납니다. 예를 들어, 파트너의 작은 행동 변화에도 과도하게 불안해하거나, 지속적인 확신과 안심이 필요한 모습을 보입니다. 또한 관계에 과도하게 몰입하여 자신의 정체성을 잃어버리기도 합니다.

연인 관계에서는 과도한 확인과 안심 추구 행동이 두드러집니다. 파트너의 연락이 늦어지면 극도의 불안을 느끼거나, 사소한 말과 행동에서 거절의 신호를 읽으려 합니다. 파트너에게 지속적인 확신과 관심을 요구하며, 관계에 과도하게 매달리는 경향이 있습니다. 이러한 행동은 오히려 파트너를 부담스럽게 만들어 원하지 않는 거리감을 만들 수 있습니다.

이러한 불안형 애착은 스트레스나 갈등 상황에서 더욱 강화됩니다. 상대방의 작은 거리두기에도 강한 불안과 버림받음의 두려움을 경험하며, 이는 오히려 관계를 악화시키는 결과를 초래할 수 있습니다. 자존감이 관계의 상태에 크게 영향을 받으며, 거절이나 이별에 대해 극도의 두려움을 느낍니다.`,
    development: [
      "자기 가치감을 관계와 분리하여 발전시키세요",
      "과도한 확신 추구 행동을 알아차리고 조절하세요",
      "건강한 경계 설정을 연습하세요",
      "독립적인 활동과 취미를 발전시키세요",
      "불안한 감정을 알아차리고 자기 위로하는 법을 배우세요"
    ]
  },
  'avoidant': {
    analysis: `회피형 애착은 친밀감과 의존을 불편해하는 유형입니다. 초기 양육자와의 관계에서 정서적 거리두기나 거절을 경험했으며, 이로 인해 자기 보호적인 독립성과 친밀감에 대한 방어가 발달했습니다.

형성 과정에서 양육자는 아이의 정서적 필요나 의존 욕구에 적절히 반응하지 않았거나, 오히려 냉담하게 대응했을 수 있습니다. 아이는 자신의 욕구를 억제하고 독립적으로 행동하는 것이 안전하다는 것을 학습했으며, 이는 성인이 되어서도 친밀한 관계를 형성하는 데 어려움으로 나타납니다.

실제 관계에서는 정서적 거리두기와 독립성 추구가 두드러집니다. 예를 들어, 관계가 너무 가까워지면 불편함을 느끼고 거리를 두거나, 감정 표현과 의존을 어려워합니다. 또한 자신의 취약성을 보이는 것을 극도로 꺼리며, 타인의 정서적 요구를 부담스러워합니다.

연인 관계에서는 정서적 친밀감을 회피하는 패턴이 뚜렷합니다. 관계가 깊어질수록 불편함을 느끼고 거리를 두려 하며, 파트너의 정서적 요구나 친밀감 표현에 어색함을 느낍니다. 갈등을 피하기 위해 진정한 감정을 숨기거나, 관계가 위협적으로 느껴질 때 갑자기 철수하는 경향이 있습니다. 이는 파트너에게 거절감을 주거나 관계의 발전을 저해할 수 있습니다.

이러한 회피형 애착은 친밀한 관계가 요구되는 상황에서 더욱 강화됩니다. 상대방이 정서적 친밀감을 요구할 때 불편함을 느끼고 철수하는 경향이 있으며, 이는 의미 있는 관계 형성을 방해할 수 있습니다. 겉으로는 독립적이고 자족적으로 보이지만, 내면에는 깊은 외로움과 연결에 대한 욕구가 있을 수 있습니다.`,
    development: [
      "점진적으로 감정 표현과 친밀감을 늘려보세요",
      "자신의 회피 패턴을 알아차리고 이해하세요",
      "취약성을 보이는 것도 강점이 될 수 있음을 인정하세요",
      "타인의 정서적 요구를 수용하는 연습을 하세요",
      "독립성과 친밀감 사이의 건강한 균형을 찾으세요"
    ]
  },
  'disorganized': {
    analysis: `혼란형 애착은 가장 복잡하고 어려운 애착 패턴을 보이는 유형입니다. 초기 양육자와의 관계에서 심각한 외상이나 학대, 방임을 경험했을 수 있으며, 이로 인해 관계에 대한 깊은 양가성과 예측 불가능한 반응 패턴이 형성되었습니다.

형성 과정에서 양육자는 아이에게 위협적이거나 두려움의 대상이었을 수 있으며, 동시에 의존해야 하는 대상이었습니다. 이러한 모순된 경험은 '접근-회피' 딜레마를 만들어내며, 이는 성인기의 관계에서도 혼란스러운 패턴으로 지속됩니다.

실제 관계에서는 불안정하고 예측하기 어려운 행동 패턴을 보입니다. 예를 들어, 친밀감을 강하게 원하면서도 동시에 두려워하거나, 관계에서 극단적인 감정 변화를 경험합니다. 또한 자신과 타인에 대한 일관된 이미지를 유지하기 어려워하며, 관계에서 혼란스러운 신호를 보낼 수 있습니다.

연인 관계에서는 극단적인 접근-회피 패턴을 보입니다. 때로는 강한 친밀감과 의존 욕구를 보이다가도, 갑자기 극도의 거리두기와 불신을 표현할 수 있습니다. 파트너와의 관계에서 안정감을 찾기 어려우며, 과거의 외상 경험이 현재 관계에 투영되어 예측하기 어려운 반응을 보일 수 있습니다. 이러한 혼란스러운 패턴은 파트너에게도 큰 혼란과 어려움을 줄 수 있습니다.

이러한 혼란형 애착은 스트레스 상황에서 더욱 불안정해집니다. 관계에서 작은 트리거에도 강한 정서적 반응을 보일 수 있으며, 때로는 해리나 극단적인 행동으로 이어질 수 있습니다. 자기 조절이 어렵고 관계에서 안정감을 찾기 힘들어하며, 과거의 외상 경험이 현재의 관계에 강하게 영향을 미칩니다.`,
    development: [
      "전문적인 치료와 상담을 통해 과거의 외상을 다루세요",
      "자신의 트리거와 반응 패턴을 이해하고 알아차리세요",
      "안정적이고 예측 가능한 일상 루틴을 만드세요",
      "점진적으로 안전한 관계 경험을 쌓아가세요",
      "감정 조절과 자기 돌봄 기술을 개발하세요"
    ]
  }
}; 